import React from 'react'
import DataComponent from 'EurestoComponents/DataComponent'

export default React.memo(props => {

    return <div>TEST</div>


})


// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/ModeVente/index.js